import AppBar from "components/common/AppBar";
import PageLayout from "../../components/common/PageLayout";
import { useEffect, useState } from "react";
import Body from "components/common/Body";

const FavoriteBJItem = ({ uid }: { uid: string }) => {
    const [userInfo, setUserInfo] = useState<any>(null);
    const [bjInfo, setBJInfo] = useState<any>(null);
    const [extInfo, setExtInfo] = useState<any>(null);

    useEffect(() => {
        if(!uid) return;
        
        FriendsDataManager.getInfo(uid, (err: any, result: any) => {
            if(!result) return;

            setUserInfo(result);
        });

        PrimeDataManager.getBJProfile(uid, (err: any, result: any) => {
            if(err){
                console.error(err);
                return;
            }

            setBJInfo(result);
        });

        PrimeDataManager.getBJExtraProfile(uid, (err: any, result: any) => {
            if(err){
                console.error(err);
                return;
            }

            setExtInfo(result);
        });
    },[uid]);

    // Helper function to get location HTML
    const getLocationHTML = (country: string) => {
        if (!country) country = 'EU';
        const flagUrl = `/images/nation_flag/${country.toLowerCase()}.svg`;
        return (
            <>
                <img className="flag" width="16" height="11" src={flagUrl} alt={country} />
                <span>&nbsp;{country}</span>
            </>
        );
    };

    // Helper function to get media element
    const getMediaElement = () => {
        if (!userInfo) return null;
        
        const PhotoManager = (window as any).PhotoManager;
        if (!PhotoManager) return null;

        const imageUrl = PhotoManager.getPrimePhotoURL(userInfo, true);
        const videoUrl = PhotoManager.getPrimeVideoURL(userInfo);

        if (videoUrl) {
            return (
                <video 
                    className="prime-match-list-photo" 
                    src={videoUrl} 
                    loop 
                    muted
                    playsInline
                    autoPlay
                    preload="metadata"
                    poster={imageUrl}
                />
            );
        } else if (imageUrl) {
            return (
                <img 
                    className="prime-match-list-photo" 
                    src={imageUrl} 
                    alt={userInfo.nick || ''} 
                />
            );
        }
        return null;
    };

    // Helper function to format time
    const formatTime = (timestamp: number) => {
        if (!timestamp) return 'No DATE';
        const date = new Date(timestamp);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(diff / 3600000);
        const days = Math.floor(diff / 86400000);

        if (minutes < 5) return 'Just now';
        if (minutes < 60) return `${minutes}m ago`;
        if (hours < 24) return `${hours}h ago`;
        if (days < 7) return `${days}d ago`;
        return date.toLocaleDateString();
    };

    // Helper function to format number (K, M)
    const formatNumber = (num: number) => {
        if (!num) return '0';
        if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
        if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
        return num.toString();
    };

    const cost = bjInfo?.cost || 0;
    const isOnline = bjInfo?.online || false;
    const recentCall = extInfo?.recentCall ? new Date(extInfo.recentCall) : null;
    const fans = extInfo?.fans || 0;

    function handleFavorite(event: React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();

        const element = (event.target as HTMLElement).closest('.prime-match-list-item');
        if(!element) return;

        const bj = {
            fbUid: userInfo?.uid || uid,
            country: userInfo?.country || '',
            online: false,
        };
        bj.online = (element.parentNode as HTMLElement).classList.contains('online') || false;

        const input = (event.currentTarget as HTMLInputElement).querySelector('input');
        if(!input) return;

        const isAdded = !input.checked;

        PrimeCommon.setFavorite(bj, isAdded, 'mybj', false, (error: any) => {
            if (error) {
                return;
            }
            element.classList.toggle('favorite', isAdded);
            input.checked = isAdded;

            document.getElementById('hPrimeMatchListItems')?.querySelectorAll(`[data-uid="${uid}"]`).forEach((elem)=>{
                elem.classList.toggle('favorite', isAdded);
                const input = elem.querySelector('input') as HTMLInputElement;
                if(input) {
                    input.checked = isAdded;
                }
            });
        });
    }

    function handleCall(event: React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();

        const cost = bjInfo?.cost || 0;
        PrimeCommon.makeCall(userInfo, 'mybj', cost);
    }

    return (
        <li className={isOnline ? 'online' : 'offline'}>
            <div className="prime-match-list-item favorite" data-uid={userInfo?.uid || uid}>
                <div className="prime-match-list-appbar">
                    <div className="prime-match-list-alert flexcenter">
                        <span className="prime-match-list-alert-icon linkle-icons alert"></span>
                        <div className="prime-match-list-alert-menu">
                            <div className="prime-match-list-alert-menu-report flexcenter" role="button">
                                {(window as any).brsc?.report || 'Report'}
                            </div>
                            <div className="prime-match-list-alert-menu-block flexcenter" role="button">
                                {(window as any).brsc?.block || 'Block'}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="prime-match-list-media">
                    {getMediaElement()}
                </div>
                <div className="prime-match-list-shadow"></div>
                <div className="prime-match-list-bjinfo">
                    <div className="prime-match-list-container">
                        <span className="prime-match-list-country">
                            {userInfo?.country && getLocationHTML(userInfo.country)}
                        </span>
                        <span className="prime-match-list-nick">{userInfo?.nick || ''}</span>
                        <span className={`prime-match-list-state ${isOnline ? 'prime-match-online' : ''}`}>
                            <span className="icon-brightness_1"></span>
                        </span>
                    </div>
                    <div className="prime-match-list-geminfo">
                        <div className="prime-match-list-geminfo-row flexcenter">
                            <img className="prime-match-list-geminfo-icon" src="/images/linkle/icon/coin.svg" alt="coin" />
                            <span>{cost > 0 ? `${cost} /10sec` : '?'}</span>
                        </div>
                    </div>
                    <div className="prime-match-list-desc">
                        <div className="recent-call flexcenter">
                            <span className="linkle-icons call"></span>
                            <span>{recentCall ? formatTime(recentCall.getTime()) : 'No DATE'}</span>
                        </div>
                        <span className="verbar">|</span>
                        <div className="favorite-count flexcenter">
                            <span className="linkle-icons heart"></span>
                            <span>{formatNumber(fans)}</span>
                        </div>
                    </div>
                    <div onClick={handleCall} className="prime-match-list-call flexcenter active-small">
                        <span className="ok">CALL</span>
                    </div>
                    <div onClick={handleFavorite} className="prime-match-list-favorite flexcenter active-small">
                        <div className="favorite-label">
                            <input type="checkbox" name={userInfo?.uid || uid} checked />
                            <span className="linkle-icons heart"></span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
};

const MyBJList = () => {
    const [bjList, setBJList] = useState<any[]>([]);

    useEffect(() => {
        PrimeDataManager.getBJList('mybj', null, null, (err: any, result: any) => {
            if(err){
                console.error(err);
                return;
            }

            setBJList(result);
        });
    },[]);

  return <PageLayout>
    <AppBar title="MY" leadingIcon="icons/ic_left_arrow.svg"/>
    <Body className="prime-list minicard">
        {bjList.map((uid: string) => (
            <FavoriteBJItem key={uid} uid={uid} />
        ))}
    </Body>
  </PageLayout>;
};

export default MyBJList;